import { render, staticRenderFns } from "./indicators.vue?vue&type=template&id=111a85da&scoped=true"
import script from "./indicators.vue?vue&type=script&lang=js"
export * from "./indicators.vue?vue&type=script&lang=js"
import style0 from "./indicators.vue?vue&type=style&index=0&id=111a85da&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111a85da",
  null
  
)

export default component.exports